// extracted by mini-css-extract-plugin
export default {"currentPosition":"CurrentPosition_currentPosition__QYsiI"};